export default __webpack_public_path__ + "static/media/logout.92268585.svg";